import * as React from 'react';
import { useSelector } from 'react-redux';
import { LinkButton, Image } from '@cian/ui-kit';
import { getPromos } from '../../selectors';
import { PromoCard } from '../../components/PromoCard';
import { Carousel } from '../../components/Carousel';
import { SPThemeWrapper } from '../../components/SPThemeWrapper';
import { IPromo } from '../../types/developer/promos';
import { CallbackButtonContainer } from '../CallbackButton';
import { PromoMenuContainer } from './PromoMenu';

export function Promos() {
  const promos = useSelector(getPromos);
  const slides = React.useMemo(
    () =>
      promos.map((promo, index) => (
        <PromoCard
          key={index}
          image={<Image src={promo.image} width={1100} height={300} objectFit="cover" borderRadius="0" />}
          moreInfo={getMoreInfoButton({ promo })}
          menu={<PromoMenuContainer promo={promo} />}
        />
      )),
    [promos],
  );

  if (!slides.length) {
    return null;
  }

  return <Carousel items={slides} />;
}

function getMoreInfoButton({ promo }: { promo: IPromo }) {
  if (promo.hasCallbackPopup) {
    return (
      <CallbackButtonContainer customTheme="fsk_fill_white_primary" buttonText="Узнать больше" place="more_button" />
    );
  }

  return (
    <SPThemeWrapper theme="fsk_fill_white_primary">
      <LinkButton href={promo.url} theme="fill_white_primary">
        Узнать больше
      </LinkButton>
    </SPThemeWrapper>
  );
}
